export const environment = {
    production: false,
    baseUrl: 'https://cepuat.controlexpert.expert/',
    apiEndpoint: 'https://cepuat.controlexpert.expert/api/EasyClaim/'
};
